import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { NotificationList_model } from './notification-list.model';
import { WebApiHttp } from '@pristinebase/Process/WebApiHttp.services';
import { PristineToaster } from '@pristinebase/Process/ZivameServices/PristineToaster';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { EncriptDecript } from '@pristinebase/Process/EncriptDecript';
import { ExcelService } from '@pristinebase/Process/excel.Service';
import { SessionManageMent } from '@pristinebase/Process/SessionManageMent';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss']
})
export class NotificationListComponent implements OnInit {

  dataSource : MatTableDataSource<NotificationList_model> = new MatTableDataSource<NotificationList_model>([]);
  notification_list: Array<NotificationList_model> = [];
  displayColumn: string[] = ["notification_id", "notification_type", "document_no", "external_document_no", "process_name", "is_notification_send_to_user", "notification_message" , "is_manual", "is_acknowledge" , "notification_on", "notification_by" ]


  //   displayColumn: Array<{
  //   key: string;
  //   display_key: string;
  //   type: string;
  //   filter: boolean;
  //   sort: boolean;
  //   filter_value: string
  // }> = [
  //   {key: 'notification_id', display_key: 'Notification Id', type: 'text', filter: true, sort: false, filter_value: ''},
  
  // ]

  //   get getDisplayColumn() {
  //   return this.displayColumn.map(a => a.key)
  // }


  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(public WebApiHttp: WebApiHttp,
              public _toasterService: PristineToaster,
              private spinner: NgxSpinnerService,
              private composeDialog: MatDialog,
              private _router: Router,
              public  fb: FormBuilder,
              private _encryptdecrypt: EncriptDecript,
              private _excelService: ExcelService,
            private SessionManageMent : SessionManageMent) { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource<NotificationList_model>(this.notification_list);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.GetAllVendorList();
  }

  applyFilter(filterValue: string, keyName: string) {
    this.dataSource.filter = filterValue;
    this.dataSource.filterPredicate = function (data, filter: string): boolean {
      if (data[keyName] != undefined && data[keyName] != null && data[keyName] != '') {
        return (data[keyName] != null && data[keyName] != undefined ? data[keyName].toString().toLowerCase() : '').includes(filter.toLowerCase());
      } else {
        return false
      }

    };
  }


  GetAllVendorList() {
    this.spinner.show();
    this.WebApiHttp.Get(this.WebApiHttp.ApiURLArray.GetNotificationData)
      .then(result => {
        this.notification_list = result as NotificationList_model[];
        if (this.notification_list.length > 0 && this.notification_list[0].condition.toLowerCase() == 'true') {
          this.dataSource = new MatTableDataSource<NotificationList_model>(this.notification_list);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.spinner.hide();
        } else {
          this._toasterService.onError('error', this.notification_list[0].notification_message)
          this.spinner.hide();
        }
      }, err => {
        this._toasterService.onError('error', err)
        this.spinner.hide();
      }).finally(() => {
        this.spinner.hide();
      })
  }


  Back() {
    this._router.navigate(['/notification/vendor_notification_create']);
  }


}
